import React from "react";
import {
  compose,
  withHandlers,
  withStateHandlers,
  withPropsOnChange,
} from "recompose";
import {
  Page,
  TableContainer,
  withTable,
  Pagination,
  TableSearch,
  ViewingRecords,
  AddNewButton,
} from "components/common";
import { NotificationManager } from "react-notifications";
import { XeroTableDataFetch } from "components";
import { Link } from "react-router-dom";
import { Table, Alert } from "reactstrap";
import { isEmpty } from "lodash";
import BulkArchiveButton from "./ArchiveButton";
import { Trans } from "react-i18next";

export const ContactGroupsList = ({
  selected,
  setSelected,
  ordering,
  setOrdering,
  data,
  url,
  setData,
  limit,
  offset,
  setOffset,
  refreshToken,
  xero,
  match,
  search,
  setSearch,
  xeroFilters,
  isDeleteModalOpen,
  toggleDeleteModal,
  onArchived,
  error,
  setError,
}) => (
  <Page title="Contact Groups" className="inv-table">
    <TableSearch onChange={setSearch} value={search} />
    <div>
      <AddNewButton resource="Contact Group" match={match} className="mb-2  mt-3" />
      {!isEmpty(selected) && (
      <BulkArchiveButton
        selected={selected}
        buttonProps={{ className: "mb-2  mt-3" }}
        style={{ display: "inline-block" }}
        toggleModal={toggleDeleteModal}
        isModalOpen={isDeleteModalOpen}
        onDeleted={onArchived}
        setError={setError}
      />
      )}
      {error && (
        <Alert color="danger">
          <Trans>{error.detail}</Trans>
        </Alert>
      )}
    </div>
    <div className="small">
      <TableContainer
        items={data.results}
        ordering={ordering}
        idKey="ContactGroupID"
        onOrderingChanged={setOrdering}
        selected={selected}
        onSelectedChanged={setSelected}
      >
        <Table size="sm" className="small">
          <thead>
            <tr>
              <th select style={{ width: "3em" }} />
              <th sortBy="Name">
                <Trans>Group</Trans>
              </th>
            </tr>
          </thead>
          <tbody>
            {data.loading && (
              <tr>
                <td colSpan="9" className="text-center">
                  <span className="fa fa-spinner fa-spin mt-2" />{" "}
                  <Trans>Loading...</Trans>
                </td>
              </tr>
            )}
            {data.results.map((i, idx) => (
              <tr key={i.ContactGroupID}>
                <td select />
                <td>
                  <Link to={`${match.url}/${i.ContactGroupID}`}>{i.Name}</Link>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </TableContainer>
    </div>
    <XeroTableDataFetch
      ordering={ordering}
      refreshToken={refreshToken}
      search={search}
      filters={xeroFilters}
      limit={limit}
      url={url}
      offset={offset}
      onDataFetched={setData}
    />
    <div className="clearfix">
    <div className="float-right">
      <Pagination
        size="sm"
        noPages
        limit={limit}
        offset={offset}
        onOffsetChanged={setOffset}
      />
    </div>
    <ViewingRecords
      offset={offset}
      limit={limit}
      noCount
      className="float-left"
    />
    </div>
  </Page>
);

export const enhance = compose(
    withStateHandlers(
      {
        url: "contactgroups",
      },
      {
        setState: () => (state) => ({ ...state }),
        setError: () => (error) => ({ error }),
      }
  ),
  withPropsOnChange(["search"], ({ search, setState }) => {
    const input = (search || "").replace(/"/g, "").toLowerCase();
    if (!input) return;

    setState({
      xeroFilters: {
        raw: `Name.ToLower().StartsWith("${input}") OR (EmailAddress != null AND EmailAddress.ToLower().StartsWith("${input}"))`,
      },
    });
  }),
  withTable({
    limit: 100,
  }),
  withHandlers({
    onArchived:
      ({ setState, xeroFilters }) =>
      (failed) => {
        NotificationManager.success(`Archive successful`);
        setState({ xeroFilters: { ...xeroFilters } }); // Trigger a reload
      },
  })
);

export default enhance(ContactGroupsList);
